<template>
  <span class="product-search-wrap">
    <AutoComplete
        v-model="internalModel"
        :suggestions="filteredProducts"
        @complete="searchProduct"
        @item-select="onItemSelect"
        @clear="onItemClear"
        :forceSelection="forceSelection"
        field="name"
        :minLength=3
        placeholder="Search product by code & name ..."
        class="product-search-input"
    >
      <template #item="{ item, index }">
        <div class="autocomplete-item-stack">
          <div class="autocomplete-row">
            <div class="autocomplete-product-code" :title="item.product_code">
              {{ item.product_code }}
            </div>
            <div class="autocomplete-name" :title="item.name">{{ item.name }}</div>
          </div>
          <div
              v-if="item.description"
              class="autocomplete-description"
              :title="item.description"
          >
            {{ item.description }}
          </div>
        </div>
      </template>
    </AutoComplete>
    <SearchTipsInfo v-if="showTips" />
  </span>
</template>

<script>
import SearchTipsInfo from "./SearchTipsInfo.vue";

// Single product autocomplete for BOTH catalogues: `verified` switches between
// the main products service and the cleaned/verified one (the two components
// used to be near-identical copies — ProductAutoCompleteVerified.vue is now a
// thin wrapper around this with verified=true).
export default {
  components: { SearchTipsInfo },
  props: {
    value: {
      type: [Object, String],
      default: () => {
        return ""
      }
    },
    forceSelection: {
      type: Boolean,
      default: false
    },
    verified: {
      type: Boolean,
      default: false
    },
    // Set false when the caller renders SearchTipsInfo elsewhere (e.g. next to
    // the field label) instead of inline beside the input.
    showTips: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    internalModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (typeof newValue === 'string' && !this.isProductInList(newValue)) {
          const customValue = {product_id: null, name: newValue};
          this.$emit('input', customValue);
        } else {
          this.$emit('input', newValue);
        }
      }
    },
    productService() {
      return this.verified ? this.ProductVerifiedService : this.ProductServiceV2;
    }
  },
  data() {
    return {
      filteredProducts: [],
    };
  },
  methods: {
    async searchProduct(event) {
      const q = (event && event.query ? String(event.query) : '').trim();
      if (q === '') return;

      try {
        // limit=50: the server default of 10 hid exact code matches behind
        // description/comment hits (field-reported: AGS200 unfindable).
        const urlParams = `?searchTerm=${encodeURIComponent(q)}&limit=50`;
        const response = await this.productService.searchProducts(urlParams);

        const list = response && response.data ? response.data : [];
        this.filteredProducts = Array.isArray(list) ? list : [];
      } catch (error) {
        console.error('Error fetching products:', error);
        this.filteredProducts = [];
      }
    },
    isProductInList(name) {
      return this.filteredProducts.some(product => product.name === name);
    },
    onItemSelect(event) {
      this.$emit('productSelected', event);
    },
    onItemClear(event) {
      this.$emit('productCleared', event);
    },
  }
};
</script>

<style>
/* Style remains the same as it's mainly layout-related */
.autocomplete-item-stack {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.autocomplete-description {
  font-size: 0.8rem;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.autocomplete-row {
  display: flex;
  justify-content: space-between;
}

.autocomplete-name,
.autocomplete-product-code {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.autocomplete-product-code {
  width: 40%;
}

.autocomplete-name {
  width: 60%;
}

.p-autocomplete-panel {
  max-width: 100%;
  width: auto;
}

.p-autocomplete-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
